import { z } from "zod";
import { tokenAliasOrValue } from "./base";

export const DimensionUnit = z.enum(["Pixels", "Percent", "Rem", "Ms", "Raw", "Points"]);

export const DimensionValue = z.object({
  unit: DimensionUnit,
  measure: z.number(),
});

export const DimensionTokenData = tokenAliasOrValue(DimensionValue);

export type DimensionUnit = z.infer<typeof DimensionUnit>;
export type DimensionValue = z.infer<typeof DimensionValue>;
export type DimensionTokenData = z.infer<typeof DimensionTokenData>;
